import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { currencyFormatter, formatDateTime } from '../../../common/utils/helpers';
import { transactionTypes } from '../../../common/enums/transactionTypes';
import translate from 'react-i18next/dist/commonjs/translate';
import { Button, Spin } from 'antd';
import { Row, Col } from 'react-flexbox-grid';
import { ResponsiveTable } from '../../../common/components/data-display';
import Table from 'antd/lib/table';

const { Column } = Table;


@translate()
export default class ReportTransactions extends Component {


  formatAmountString = (value) => {
        value.replace(',','.')
        return value + ' €'
  }

  render() {
    const {
      t,
      result,
      isLoading
    } = this.props;
  
    if (!result) {
      return (
        <Spin spinning={true}>
          <div className="spin-empty-content" />
        </Spin>
      );
    }

    return (
      <Spin spinning={isLoading}>
        <div className="panel-wrapper">
        <h1>{t('Report z jobu')} {result.date}</h1>

            <section className="withdraw-funds-wrapper col-xs-12 col-md-6 " >
              <section className="panel-wrapper">
                <h2 style={{color: "#0A4892", textAlign: 'left'}}>Blokované prostriedky a nespracované investičné ponuky</h2>
                
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px'}}>Blokované prostriedky investori: </p> <p className="p-in-table">{this.formatAmountString(result.amountBlockVsInvestmentsCheck.blockedAmountCreditors)}</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px'}}>Blokované prostriedky dlžníci: </p> <p className="p-in-table">{this.formatAmountString(result.amountBlockVsInvestmentsCheck.blockedAmountDebtors)}</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px'}}>Nespracované investičné ponuky: </p> <p className="p-in-table">{this.formatAmountString(result.amountBlockVsInvestmentsCheck.notPairedInvestmentOpportunities)}</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px', fontWeight: 'bold'}}>Rozdiel: </p> <p className="p-in-table" style={{fontWeight: 'bold'}}> {result.amountBlockVsInvestmentsCheck.result === 'OK' ? result.amountBlockVsInvestmentsCheck.result : this.formatAmountString(result.amountBlockVsInvestmentsCheck.result) }</p>
                </Row>
                
              </section>  
            </section>

            <section className="withdraw-funds-wrapper col-xs-12 col-md-6 " >
              <section className="panel-wrapper">
                <h2 style={{color: "#0A4892", textAlign: 'left'}}>Stav na bankových účtoch</h2>
                
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px'}}>Externý bankový účet: </p> <p className="p-in-table">{this.formatAmountString(result.bankAccountBalancesCheck.externalAmount)}</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px'}}>Interný bankový účet: </p> <p className="p-in-table">{this.formatAmountString(result.bankAccountBalancesCheck.internalAmount)}</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px'}}>Nespárované platby: </p> <p className="p-in-table">{this.formatAmountString(result.bankAccountBalancesCheck.unpairedPayment)}</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px'}}>Platby kartou - nespracované: </p> <p className="p-in-table">{this.formatAmountString(result.bankAccountBalancesCheck.unpairedCardPayment)}</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px'}}>Platby kartou - poplatky: </p> <p className="p-in-table">{this.formatAmountString(result.bankAccountBalancesCheck.sumCardPaymentsFees)}</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px'}}>Čakajúce transakcie: </p> <p className="p-in-table"> {this.formatAmountString(result.bankAccountBalancesCheck.pendingTransaction)}</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px', fontWeight: 'bold'}}>Rozdiel: </p> <p className="p-in-table" style={{fontWeight: 'bold'}}> {result.bankAccountBalancesCheck.result === 'OK' ? result.bankAccountBalancesCheck.result : this.formatAmountString(result.bankAccountBalancesCheck.result) }</p>
                </Row>
                
              </section>  
            </section>

            <section className="withdraw-funds-wrapper col-xs-12 col-md-6 " >
              <section className="panel-wrapper">
                <h2 style={{color: "#0A4892", textAlign: 'left'}}>Transakcie na Externom účte</h2>
                
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px'}}>Sumár transakcií: </p> <p className="p-in-table">{this.formatAmountString(result.externalAccountCheck.transactionSum) }</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px'}}>Externý bankový účet: </p> <p className="p-in-table">{this.formatAmountString(result.externalAccountCheck.externalAmount) }</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px', fontWeight: 'bold'}}>Rozdiel sumára a externého účtu: </p> <p className="p-in-table" style={{fontWeight: 'bold'}}>{result.externalAccountCheck.result === 'OK' ? result.externalAccountCheck.result : this.formatAmountString(result.externalAccountCheck.result) }</p>
                </Row>
                
                
              </section>  
            </section>

            <section className="withdraw-funds-wrapper col-xs-12 col-md-6 " >
              <section className="panel-wrapper">
                <h2 style={{color: "#0A4892", textAlign: 'left'}}>Klientské a bankové účty</h2>
                
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px'}}>Dlžnícke účty: </p> <p className="p-in-table">{this.formatAmountString(result.clientSystemAccountCheck.debtorsAmount)}</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px'}}>Investorské účty: </p> <p className="p-in-table">{this.formatAmountString(result.clientSystemAccountCheck.creditorsAmount)}</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px'}}>Účet Inkasárne: </p> <p className="p-in-table">{this.formatAmountString(result.clientSystemAccountCheck.executorsAmount)}</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px'}}>Poplatkový účet: </p> <p className="p-in-table">{this.formatAmountString(result.clientSystemAccountCheck.feeAccountAmount)}</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px'}}>Nespárované platby: </p> <p className="p-in-table">{this.formatAmountString(result.bankAccountBalancesCheck.unpairedPayment)}</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px'}}>Platby kartou - nespracované: </p> <p className="p-in-table">{this.formatAmountString(result.bankAccountBalancesCheck.unpairedCardPayment)}</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px'}}>Platby kartou - poplatky: </p> <p className="p-in-table">{this.formatAmountString(result.bankAccountBalancesCheck.sumCardPaymentsFees)}</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px'}}>Externý účet: </p> <p className="p-in-table">{this.formatAmountString(result.clientSystemAccountCheck.externalAmount)}</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px'}}>Čakajúce transakcie: </p> <p className="p-in-table"> {this.formatAmountString(result.bankAccountBalancesCheck.pendingTransaction)}</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px', fontWeight: 'bold'}}>Rozdiel: </p> <p className="p-in-table" style={{fontWeight: 'bold'}}> {result.clientSystemAccountCheck.result === 'OK' ? result.clientSystemAccountCheck.result : this.formatAmountString(result.clientSystemAccountCheck.result)}</p>
                </Row>
                
              </section>  
            </section>
          

            <h2 style={{color: "#0A4892", textAlign: 'left'}}>Stav účtov a transakcií Investorov a dlžníkov</h2>

            <ResponsiveTable
            dataSource={result.accountTransactionsCheck}
            rowKey={acc => acc.accountNumber}
            
            >
            <Column
              title={t('Investor/Dlžník - RČ')}
              dataIndex="accountNumber"
              key="accountNumber"
            />
            <Column
              title={t('Transakcie')}
              dataIndex="allTransactionsDiff"
              key="allTransactionsDiff"
              render={amount => this.formatAmountString(amount)}
            />

            <Column
              title={t('Stav účtov')}
              dataIndex="accountSum"
              key="accountSum"
              render={amount => this.formatAmountString(amount)}
            />
            <Column
              title={t('Rozdiel')}
              dataIndex="difference"
              key="difference"
              render={amount => this.formatAmountString(amount)}
            />


            </ResponsiveTable>


        </div>
      </Spin>
     
    )
  }
}


// WEBPACK FOOTER //
// ./src/features/transactions/components/ReportTransactions.js